<template>
    <q-dialog :model-value="modelValue" @update:model-value="$emit">
        <q-card 
            :flat="$q.dark.isActive"
            :square="$q.dark.isActive"
            :bordered="$q.dark.isActive"
            style="min-width: 500px;"
        >
            <q-toolbar :class="{'bg-primary text-white': !$q.dark.isActive}">
                <q-toolbar-title>
                    Your Profile
                </q-toolbar-title>
                <q-btn @click="edit = !edit" flat round dense :icon="edit ? 'mdi-chevron-left' : 'mdi-pencil'" class="text-white q-mr-sm">
                    <q-tooltip v-if="!edit">Edit profile</q-tooltip>
                    <q-tooltip v-else>Cancel edit</q-tooltip>
                </q-btn>
                <q-btn flat round dense icon="mdi-logout" class="text-white q-mr-sm" @click="$inertia.post(route('logout'))">
                    <q-tooltip>Logout</q-tooltip>
                </q-btn>
                <q-btn flat round dense icon="mdi-close" class="text-white" @click="closeDialog" />
            </q-toolbar>

            <q-card-section 
                class="text-center q-py-none relative-position"
                :style="'margin-bottom: 30px;background-color: ' + backgroundColor"
            >
                <div style="display: inline-table;margin-bottom: -45px;width: 100%;">
                    <ProfileDialogAvatar :user="getUser()" @update="$emit('updated', $event)" />
                    <div class="text-blue-grey-5 q-mt-sm">{{ GetRole() }}</div>
                </div>
            </q-card-section>

            <q-card-section v-if="!edit" class="q-pb-none q-px-none q-pt-lg">
                <q-list :separator="$q.dark.isActive">
                    <q-item :class="{'bg-grey-2': !$q.dark.isActive}">
                        <q-item-section>
                            <q-item-label class="text-bold">Name:</q-item-label>
                            <q-item-label class="q-pl-md">{{ getUser().name }}</q-item-label>
                        </q-item-section>
                    </q-item>
                    <q-item>
                        <q-item-section>
                            <q-item-label class="text-bold">Email:</q-item-label>
                            <q-item-label class="q-pl-md">
                                {{ getUser().email }}
                                <q-badge v-if="getUser().email_verified_at == null" class="q-ml-sm">Unverified</q-badge>
                            </q-item-label>
                        </q-item-section>
                    </q-item>
                </q-list>
            </q-card-section>
            <q-card-section v-else class="q-pb-none q-px-none q-pt-lg">
                <q-list :separator="$q.dark.isActive">
                    <q-item :class="{'bg-grey-2': !$q.dark.isActive}">
                        <q-item-section>
                            <q-input v-model="name" label="Name" />
                        </q-item-section>
                    </q-item>
                    <q-item>
                        <q-item-section>
                            <q-input v-model="email" label="Email" type="email" />
                        </q-item-section>
                    </q-item>
                    <q-item :class="{'bg-grey-2': !$q.dark.isActive}">
                        <q-item-section>
                            <q-input 
                                v-model="password_old"
                                label="Current Password"
                                :type="password_old_show ? 'text' : 'password'"
                                :error="password_old_error"
                                :error-message="password_old_error_message"
                            >
                                <template #append>
                                    <q-btn
                                        @click.prevent="password_old_show = !password_old_show"
                                        flat
                                        dense
                                        :icon="`mdi-eye${password_old_show ? '-off' : ''}`"
                                        class="q-ml-sm"
                                    >
                                        <q-tooltip>{{password_old_show ? 'Hide' : 'Show'}} password</q-tooltip>
                                    </q-btn>
                                    <q-btn
                                        @click.prevent="change_pw = !change_pw"
                                        flat
                                        dense
                                        :icon="`mdi-chevron-${change_pw? 'up' : 'down'}`"
                                        class="q-ml-sm"
                                    >
                                        <q-tooltip>Change password</q-tooltip>
                                    </q-btn>
                                </template>
                            </q-input>
                        </q-item-section>
                    </q-item>
                    <q-item v-if="change_pw">
                        <q-item-section>
                            <q-input 
                                v-model="password" 
                                label="New Password"
                                :type="password_show ? 'text' : 'password'"
                                :error="password_error"
                                :error-message="password_error_message"
                            >
                                <template #append>
                                    <q-btn
                                        @click.prevent="password_show = !password_show"
                                        flat
                                        dense
                                        :icon="`mdi-eye${password_show ? '-off' : ''}`"
                                        class="q-ml-sm"
                                    >
                                        <q-tooltip>{{password_show ? 'Hide' : 'Show'}} password</q-tooltip>
                                    </q-btn>
                                </template>
                            </q-input>
                        </q-item-section>
                    </q-item>
                    <q-item v-if="change_pw" :class="{'bg-grey-2': !$q.dark.isActive}">
                        <q-item-section>
                            <q-input 
                                :type="password_confirmation_show ? 'text' : 'password'"
                                label="New Password Again"
                                v-model="password_confirmation"
                                :error="password_confirmation_error"
                                :error-message="password_confirmation_error_message"
                            >
                                <template #append>
                                    <q-btn
                                        @click.prevent="password_confirmation_show = !password_confirmation_show"
                                        flat
                                        dense
                                        :icon="`mdi-eye${password_confirmation_show ? '-off' : ''}`"
                                        class="q-ml-sm"
                                    >
                                        <q-tooltip>{{password_confirmation_show ? 'Hide' : 'Show'}} password</q-tooltip>
                                    </q-btn>
                                </template>
                            </q-input>
                        </q-item-section>
                    </q-item>
                </q-list>
            </q-card-section>

            <q-card-section class="q-py-sm text-right">
                <q-btn flat class="q-mr-sm" @click="$inertia.visit('/user/' + getUser().id)">
                    Go to user page
                </q-btn>
                <q-btn flat class="q-mr-sm" color="positive" label="Save" v-if="edit" @click="saveProfile()" :disable="!password_old.length">
                    <q-tooltip v-if="!password_old.length" color="negative" icon="mdi-close">Please fill in your password!</q-tooltip>
                    <q-tooltip v-else>Save changes</q-tooltip>
                </q-btn>
                <q-btn v-if="edit" flat color="negative" label="Cancel" @click="edit = false" />
                <q-btn flat :color="$q.dark.isActive ? 'secondary' : 'primary'" label="Close" @click="closeDialog" />
            </q-card-section>
            
            <q-inner-loading :showing="loading">
                <q-spinner
                    v-if="loadDataSuccess == null"
                    color="primary"
                    size="3em"
                />
                <q-icon size="3em" v-else-if="loadDataSuccess" name="mdi-check" class="text-positive" />
                <q-icon size="3em" v-else name="mdi-close" class="text-negative" />
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<script>
import ProfileDialogAvatar from './avatar.vue';

export default {
    name: 'ProfileDialog',
    props: {
        modelValue: Boolean,
    },
    components: {
        ProfileDialogAvatar,
    },
    data() {
        return {
            edit: false,
            loading: false,
            loadDataSuccess: null,
            change_pw: false,
            name: this.getUser().name,
            email: this.getUser().email,
            password: '',
            password_show: false,
            password_error: false,
            password_error_message: '',
            password_old: '',
            password_old_show: false,
            password_old_error: false,
            password_old_error_message: '',
            password_confirmation: '',
            password_confirmation_show: false,
            password_confirmation_error: false,
            password_confirmation_error_message: '',
            submitted: false,
        };
    },
    methods: {
        reset() {
            this.name = this.getUser().name;
            this.email = this.getUser().email;
            this.change_pw = false;

            this.password = '';
            this.password_show = false;
            this.password_error = false;
            this.password_error_message = '';
            this.password_old = '';
            this.password_old_show = false;
            this.password_old_error = false;
            this.password_old_error_message = '';
            this.password_confirmation = '';
            this.password_confirmation_show = false;
            this.password_confirmation_error = false;
            this.password_confirmation_error_message = '';
        },
        saveProfile() {
            if (this.password !== this.password_confirmation) {
                this.$q.notify({
                    color: 'negative',
                    textColor: 'white',
                    icon: 'mdi-key-remove',
                    message: 'Password and confirmation does not match!',
                    position: 'top',
                    timeout: 5000,
                });
                return;
            }

            this.submitted = Date.now();

            this.loading = true;
            this.axios
                .post('/profile', {
                    name: this.name,
                    email: this.email,
                    password: this.password,
                    password_old: this.password_old,
                    change_password: this.change_pw,
                    password_confirmation: this.password_confirmation,
                })
                .then(({ data }) => {
                    if (data.success) {
                        this.$emit('updated');
                        this.edit = false;
                        this.loadDataSuccess = true;
                    } else {
                        this.loadDataSuccess = false;

                        if (data.error) {
                            this.$q.notify({
                                color: 'negative',
                                textColor: 'white',
                                icon: 'mdi-key-remove',
                                message: data.error,
                                position: 'top',
                                timeout: 5000,
                            });
                        }
                    }
                })
                .catch((e) => {
                    this.loadDataSuccess = false;
                    console.error(e);
                })
                .finally(() => {
                    setTimeout(() => {
                        this.loading = false;
                        this.loadDataSuccess = null;
                        this.$emit('newWorkOrder', data.work_order.id);
                    }, 2200);
                });
        },
        closeDialog() {
            if (this.isModified) {
                if (
                    confirm(
                        'You have unsaved changes. Are you sure you want to cancel?',
                    )
                ) {
                    this.$emit('update:modelValue', false);
                }
            } else {
                this.$emit('update:modelValue', false);
            }
        },
    },
    computed: {
        isModified() {
            return (
                (this.name !== this.getUser().name ||
                    this.email !== this.getUser().email ||
                    this.password.length ||
                    this.password_confirmation.length) &&
                this.edit
            );
        },
        splitName() {
            let name = this.getUser().name;
            let nonce = this.getUser()?.employee_id ?? this.getUser()?.id ?? 0;

            nonce += Math.floor(new Date(this.getUser().created_at).getTime() / 1000);

            if (typeof name === 'string') {
                const split = name.split(' ');
                name = {
                    id: nonce,
                    first_name: split[0].trim(),
                    last_name: split[1]?.trim() ?? '',
                };
            }

            return name;
        },
        backgroundColor() {
            return this.stringToHexColor(
                this.splitName.id + 
                this.splitName.first_name + 
                this.splitName.last_name
            );
        },
    },
    watch: {
        edit(val) {
            // Probably redundant, but just in case
            const submittedCheck = !!this.submitted
                ? Date.now() - this.submitted <= 1e4
                : false;

            if (!val && submittedCheck) {
                this.reset();
            }

            if (!val && this.isModified && !submittedCheck) {
                if (
                    confirm(
                        'You have unsaved changes. Are you sure you want to cancel?',
                    )
                ) {
                    this.reset();
                } else {
                    this.edit = true;
                }
            }
        },
        modelValue(val) {
            this.reset();

            if (!val) {
                this.edit = false;
            }
        },
        password_confirmation(val) {
            if (!val.length) return;

            if (this.password !== val || this.password.length >= val.length) {
                this.password_error = true;
                this.password_error_message =
                    'Password confirmation does not match password';
                this.password_confirmation_error = true;
                this.password_confirmation_error_message =
                    'Password confirmation does not match password';
            } else {
                this.password_error = false;
                this.password_error_message = '';
                this.password_confirmation_error = false;
                this.password_confirmation_error_message = '';
            }
        },
    },
};
</script>

<style>
</style>